module.exports = __webpack_public_path__ + "images/product_jalapeno_1.7e11ac22.jpg";